// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_socialButtonsBlockButton__eSKnX {
  display: flex;
  background-color: var(--color-white) !important;
  border: 1px solid var(--color-gray-strokes) !important;
  color: var(--color-black) !important;
}
.styles_socialButtonsBlockButton__eSKnX:hover {
  background-color: var(--color-gray-light) !important;
  border-color: var(--color-blue-light) !important;
}
.styles_socialButtonsBlockButton__eSKnX svg {
  color: inherit !important;
}

.styles_socialButtonsBlockButtonText__HnP9N {
  font: var(--typography-label);
  color: var(--color-black) !important;
}

.styles_authContainer__ivo9z {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  min-height: calc(100vh - 100px);
  justify-content: center;
  padding: 40px 20px;
}
.styles_authContainer__ivo9z.styles_showHeader__mFoL8 {
  min-height: calc(100vh - 200px);
}

.styles_cardBox__I\\+sLY {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  border-radius: 16px;
  gap: 0;
  background-color: var(--color-white);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
@media (min-width: 768px) {
  .styles_cardBox__I\\+sLY {
    border-radius: 40px;
    padding: 40px;
  }
}

.styles_card__13Sl2 {
  border: none;
  box-shadow: none;
  padding: 0;
  gap: 24px;
  width: 100%;
}

.styles_logoBox__2TpE0 {
  display: none;
}

.styles_headerTitle__g9SsF {
  font: var(--typography-h2);
}

.styles_headerSubtitle__BDZKa {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
}

.styles_socialButtons__iiaeJ {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (min-width: 768px) {
  .styles_socialButtons__iiaeJ {
    flex-direction: row;
  }
}

.styles_main__x37By {
  gap: 32px;
}

.styles_formFieldLabel__cMumP {
  font: var(--typography-body-m-regular);
}

.styles_formFieldInput__HRFwS {
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  color: var(--color-black);
  background-color: var(--color-white);
  transition: all 0.2s ease;
  outline: none;
}
.styles_formFieldInput__HRFwS::placeholder {
  color: var(--color-text-secondary);
}
.styles_formFieldInput__HRFwS:hover, .styles_formFieldInput__HRFwS:focus {
  border-color: var(--color-blue-light) !important;
  box-shadow: 0 0 0 1px var(--color-blue-light) !important;
}
.styles_formFieldInput__HRFwS:disabled {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}
.styles_formFieldInput__HRFwS:disabled::placeholder {
  color: var(--color-text-secondary);
}
.styles_formFieldInput__HRFwS.styles_cl-internal-error__puGiA {
  border-color: var(--color-error);
  box-shadow: 0 0 0 1px var(--color-error);
}
.styles_formFieldInput__HRFwS:invalid {
  border-color: var(--color-error);
  box-shadow: 0 0 0 1px var(--color-error);
}
.styles_formFieldInput__HRFwS:hover:not(:disabled) {
  border-color: var(--color-blue-light);
}

.styles_formButtonPrimary__LnjfU {
  font: var(--typography-label);
  background-color: var(--color-black);
}

.styles_buttonArrowIcon__qfb8P {
  content: none !important;
  background: none !important;
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}

.styles_footer__NnpUM {
  width: 100%;
  background: var(--color-white);
}

.styles_footerAction__SmDcW {
  background: var(--color-white);
  font: var(--typography-body-s-regular);
}

.styles_header__dXF94 svg {
  display: none;
}

.styles_formFieldInputShowPasswordButton__-KI1O {
  background-color: var(--color-white) !important;
  border: 1px solid var(--color-gray-strokes) !important;
  color: var(--color-black) !important;
}
.styles_formFieldInputShowPasswordButton__-KI1O:hover {
  background-color: var(--color-gray-light) !important;
  border-color: var(--color-blue-light) !important;
}
.styles_formFieldInputShowPasswordButton__-KI1O svg {
  color: var(--color-black) !important;
}

/* Custom signup form styles */
.styles_customForm__fGjGl {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 400px;
}

.styles_formField__30mku {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_formLabel__9XGPp {
  font: var(--typography-body-m-medium);
  color: var(--color-black);
}

.styles_fieldError__8ow92 {
  font: var(--typography-body-s-regular);
  color: var(--color-error);
  margin-top: 4px;
}

.styles_errorBanner__9htJU {
  padding: 12px 16px;
  background-color: rgba(206, 32, 33, 0.1);
  border: 1px solid var(--color-error);
  border-radius: 8px;
  color: var(--color-error);
  font: var(--typography-body-s-regular);
  text-align: center;
}

.styles_verificationText__X3IV3 {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
  text-align: center;
  margin: 0;
}
.styles_verificationText__X3IV3 strong {
  color: var(--color-black);
}

.styles_resendButton__DWq3P {
  background: none;
  border: none;
  color: var(--color-primary);
  font: var(--typography-body-s-regular);
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}
.styles_resendButton__DWq3P:hover {
  color: var(--color-primary-hover);
}
.styles_resendButton__DWq3P:disabled {
  color: var(--color-text-secondary);
  cursor: not-allowed;
}

.styles_footerText__1MBBL {
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
  text-align: center;
}

.styles_footerLink__h6OtR {
  color: var(--color-primary);
  text-decoration: none;
}
.styles_footerLink__h6OtR:hover {
  text-decoration: underline;
}

/* OAuth buttons */
.styles_oauthButtons__pD--I {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.styles_oauthButton__MpbJB {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  font: var(--typography-label);
  color: var(--color-black);
  cursor: pointer;
  transition: all 0.2s ease;
}
.styles_oauthButton__MpbJB:hover:not(:disabled) {
  background-color: var(--color-gray-light);
  border-color: var(--color-blue-light);
}
.styles_oauthButton__MpbJB:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.styles_oauthIcon__TTLFd {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Divider */
.styles_divider__dD\\+sh {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 4px 0;
}
.styles_divider__dD\\+sh::before, .styles_divider__dD\\+sh::after {
  content: "";
  flex: 1 1;
  border-bottom: 1px solid var(--color-gray-strokes);
}

.styles_dividerText__di2rm {
  padding: 0 16px;
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
}

/* Name fields row */
.styles_nameFields__0zNlb {
  display: flex;
  gap: 12px;
}
.styles_nameFields__0zNlb .styles_formField__30mku {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/screens/auth/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,+CAAA;EACA,sDAAA;EACA,oCAAA;AAAF;AAEE;EACE,oDAAA;EACA,gDAAA;AAAJ;AAIE;EACE,yBAAA;AAFJ;;AAMA;EACE,6BAAA;EACA,oCAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;AAHF;AAKE;EACE,+BAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,oCAAA;EACA,yCAAA;AAJF;AClCE;ED8BF;IAWI,mBAAA;IACA,aAAA;EAHF;AACF;;AAMA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,sCAAA;EACA,kCAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;ACnEE;EDmEF;IAMI,mBAAA;EAFF;AACF;;AAKA;EACE,SAAA;AAFF;;AAKA;EACE,sCAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;AAFF;AAIE;EACE,kCAAA;AAFJ;AAKE;EAEE,gDAAA;EACA,wDAAA;AAJJ;AAOE;EACE,8CAAA;EACA,0CAAA;EACA,kCAAA;EACA,mBAAA;AALJ;AAOI;EACE,kCAAA;AALN;AASE;EACE,gCAAA;EACA,wCAAA;AAPJ;AAUE;EACE,gCAAA;EACA,wCAAA;AARJ;AAWE;EACE,qCAAA;AATJ;;AAaA;EACE,6BAAA;EACA,oCAAA;AAVF;;AAaA;EACE,wBAAA;EACA,2BAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;AAVF;;AAaA;EACE,WAAA;EACA,8BAAA;AAVF;;AAaA;EACE,8BAAA;EACA,sCAAA;AAVF;;AAcE;EACE,aAAA;AAXJ;;AAeA;EACE,+CAAA;EACA,sDAAA;EACA,oCAAA;AAZF;AAcE;EACE,oDAAA;EACA,gDAAA;AAZJ;AAeE;EACE,oCAAA;AAbJ;;AAiBA,8BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAdF;;AAiBA;EACE,qCAAA;EACA,yBAAA;AAdF;;AAiBA;EACE,sCAAA;EACA,yBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,wCAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;EACA,sCAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,sCAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;AAdF;AAgBE;EACE,yBAAA;AAdJ;;AAkBA;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,sCAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AAfF;AAiBE;EACE,iCAAA;AAfJ;AAkBE;EACE,kCAAA;EACA,mBAAA;AAhBJ;;AAoBA;EACE,sCAAA;EACA,kCAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,2BAAA;EACA,qBAAA;AAjBF;AAmBE;EACE,0BAAA;AAjBJ;;AAqBA,kBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;AAlBF;AAoBE;EACE,yCAAA;EACA,qCAAA;AAlBJ;AAqBE;EACE,YAAA;EACA,mBAAA;AAnBJ;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AApBF;;AAuBA,YAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AApBF;AAsBE;EAEE,WAAA;EACA,SAAA;EACA,kDAAA;AArBJ;;AAyBA;EACE,eAAA;EACA,sCAAA;EACA,kCAAA;AAtBF;;AAyBA,oBAAA;AACA;EACE,aAAA;EACA,SAAA;AAtBF;AAwBE;EACE,SAAA;AAtBJ","sourcesContent":["@import \"mixins\";\n.socialButtonsBlockButton {\n  display: flex;\n  background-color: var(--color-white) !important;\n  border: 1px solid var(--color-gray-strokes) !important;\n  color: var(--color-black) !important;\n    \n  &:hover {\n    background-color: var(--color-gray-light) !important;\n    border-color: var(--color-blue-light) !important;\n  }\n  \n  // Ensure the icon and text are visible\n  svg {\n    color: inherit !important;\n  }\n}\n\n.socialButtonsBlockButtonText {\n  font: var(--typography-label);\n  color: var(--color-black) !important;\n}\n\n.authContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  min-height: calc(100vh - 100px);\n  justify-content: center;\n  padding: 40px 20px;\n\n  &.showHeader {\n    min-height: calc(100vh - 200px);\n  }\n}\n\n.cardBox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 16px;\n  border-radius: 16px;\n  gap: 0;\n  background-color: var(--color-white);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n\n  @include md {\n    border-radius: 40px;\n    padding: 40px;\n  }\n}\n\n.card {\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  gap: 24px;\n  width: 100%;\n}\n\n.logoBox {\n  display: none;\n}\n\n.headerTitle {\n  font: var(--typography-h2);\n}\n\n.headerSubtitle {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n}\n\n.socialButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @include md {\n    flex-direction: row;\n  }\n}\n\n.main {\n  gap: 32px;\n}\n\n.formFieldLabel {\n  font: var(--typography-body-m-regular);\n}\n\n.formFieldInput {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  color: var(--color-black);\n  background-color: var(--color-white);\n  transition: all 0.2s ease;\n  outline: none;\n\n  &::placeholder {\n    color: var(--color-text-secondary);\n  }\n\n  &:hover,\n  &:focus {\n    border-color: var(--color-blue-light) !important;\n    box-shadow: 0 0 0 1px var(--color-blue-light) !important;\n  }\n\n  &:disabled {\n    background-color: var(--color-button-disabled);\n    border-color: var(--color-button-disabled);\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n\n    &::placeholder {\n      color: var(--color-text-secondary);\n    }\n  }\n\n  &.cl-internal-error {\n    border-color: var(--color-error);\n    box-shadow: 0 0 0 1px var(--color-error);\n  }\n\n  &:invalid {\n    border-color: var(--color-error);\n    box-shadow: 0 0 0 1px var(--color-error);\n  }\n\n  &:hover:not(:disabled) {\n    border-color: var(--color-blue-light);\n  }\n}\n\n.formButtonPrimary {\n  font: var(--typography-label);\n  background-color: var(--color-black);\n}\n\n.buttonArrowIcon {\n  content: none !important;\n  background: none !important;\n  width: 0 !important;\n  height: 0 !important;\n  display: none !important;\n}\n\n.footer {\n  width: 100%;\n  background: var(--color-white);\n}\n\n.footerAction {\n  background: var(--color-white);\n  font: var(--typography-body-s-regular);\n}\n\n.header {\n  svg {\n    display: none;\n  }\n}\n\n.formFieldInputShowPasswordButton {\n  background-color: var(--color-white) !important;\n  border: 1px solid var(--color-gray-strokes) !important;\n  color: var(--color-black) !important;\n\n  &:hover {\n    background-color: var(--color-gray-light) !important;\n    border-color: var(--color-blue-light) !important;\n  }\n\n  svg {\n    color: var(--color-black) !important;\n  }\n}\n\n/* Custom signup form styles */\n.customForm {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  max-width: 400px;\n}\n\n.formField {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.formLabel {\n  font: var(--typography-body-m-medium);\n  color: var(--color-black);\n}\n\n.fieldError {\n  font: var(--typography-body-s-regular);\n  color: var(--color-error);\n  margin-top: 4px;\n}\n\n.errorBanner {\n  padding: 12px 16px;\n  background-color: rgba(206, 32, 33, 0.1);\n  border: 1px solid var(--color-error);\n  border-radius: 8px;\n  color: var(--color-error);\n  font: var(--typography-body-s-regular);\n  text-align: center;\n}\n\n.verificationText {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n  text-align: center;\n  margin: 0;\n\n  strong {\n    color: var(--color-black);\n  }\n}\n\n.resendButton {\n  background: none;\n  border: none;\n  color: var(--color-primary);\n  font: var(--typography-body-s-regular);\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n\n  &:hover {\n    color: var(--color-primary-hover);\n  }\n\n  &:disabled {\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n  }\n}\n\n.footerText {\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\n.footerLink {\n  color: var(--color-primary);\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n/* OAuth buttons */\n.oauthButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.oauthButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  font: var(--typography-label);\n  color: var(--color-black);\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background-color: var(--color-gray-light);\n    border-color: var(--color-blue-light);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.oauthIcon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* Divider */\n.divider {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: 4px 0;\n\n  &::before,\n  &::after {\n    content: \"\";\n    flex: 1;\n    border-bottom: 1px solid var(--color-gray-strokes);\n  }\n}\n\n.dividerText {\n  padding: 0 16px;\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary);\n}\n\n/* Name fields row */\n.nameFields {\n  display: flex;\n  gap: 12px;\n\n  .formField {\n    flex: 1;\n  }\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socialButtonsBlockButton": `styles_socialButtonsBlockButton__eSKnX`,
	"socialButtonsBlockButtonText": `styles_socialButtonsBlockButtonText__HnP9N`,
	"authContainer": `styles_authContainer__ivo9z`,
	"showHeader": `styles_showHeader__mFoL8`,
	"cardBox": `styles_cardBox__I+sLY`,
	"card": `styles_card__13Sl2`,
	"logoBox": `styles_logoBox__2TpE0`,
	"headerTitle": `styles_headerTitle__g9SsF`,
	"headerSubtitle": `styles_headerSubtitle__BDZKa`,
	"socialButtons": `styles_socialButtons__iiaeJ`,
	"main": `styles_main__x37By`,
	"formFieldLabel": `styles_formFieldLabel__cMumP`,
	"formFieldInput": `styles_formFieldInput__HRFwS`,
	"cl-internal-error": `styles_cl-internal-error__puGiA`,
	"formButtonPrimary": `styles_formButtonPrimary__LnjfU`,
	"buttonArrowIcon": `styles_buttonArrowIcon__qfb8P`,
	"footer": `styles_footer__NnpUM`,
	"footerAction": `styles_footerAction__SmDcW`,
	"header": `styles_header__dXF94`,
	"formFieldInputShowPasswordButton": `styles_formFieldInputShowPasswordButton__-KI1O`,
	"customForm": `styles_customForm__fGjGl`,
	"formField": `styles_formField__30mku`,
	"formLabel": `styles_formLabel__9XGPp`,
	"fieldError": `styles_fieldError__8ow92`,
	"errorBanner": `styles_errorBanner__9htJU`,
	"verificationText": `styles_verificationText__X3IV3`,
	"resendButton": `styles_resendButton__DWq3P`,
	"footerText": `styles_footerText__1MBBL`,
	"footerLink": `styles_footerLink__h6OtR`,
	"oauthButtons": `styles_oauthButtons__pD--I`,
	"oauthButton": `styles_oauthButton__MpbJB`,
	"oauthIcon": `styles_oauthIcon__TTLFd`,
	"divider": `styles_divider__dD+sh`,
	"dividerText": `styles_dividerText__di2rm`,
	"nameFields": `styles_nameFields__0zNlb`
};
export default ___CSS_LOADER_EXPORT___;
